"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndianaRules = void 0;
const browser_1 = require("encamp-prisma/generated/browser");
const stateWasteCodes_1 = require("../stateWasteCodes");
const _FEDERAL_1 = require("./_FEDERAL");
const _stateRules_1 = require("./_stateRules");
/**
 * Indiana (IDEM) uses the federal thresholds. Its one
 * departure is which waste counts acute: its chemical munitions count toward
 * the acute limits.
 */
/**
 * Indiana's six chemical munitions, all under I001: 329 IAC 3.1-6-3(a)-(b).
 * The VX carve-out in 3.1-6-3(c) can't be told apart by code, so VX waste is
 * held acute too (over-strict).
 */
const IN_ACUTE_WASTE_CODES = ["I001"];
/** Indiana (IDEM) accumulation limits: the federal thresholds, with its own acute codes. */
class IndianaRules extends _stateRules_1.StateRules {
    constructor() {
        super(...arguments);
        this.stateStatusDomain = [];
        this.adoptsEpisodicEvents = true;
    }
    facilityThresholds(facility) {
        return _FEDERAL_1.Federal.onSiteThresholds(facility);
    }
    areaThresholds(situation) {
        return _FEDERAL_1.Federal.areaThresholds(situation);
    }
    governingProgram(container) {
        return _FEDERAL_1.Federal.governingProgram(container);
    }
    accumulationCategory(container) {
        if (container.classification === browser_1.WasteClassification.RCRA_ACUTELY_HAZARDOUS) {
            return { value: "ACUTE" };
        }
        const hasAcuteStateWasteCode = (0, stateWasteCodes_1.hasSomeOfGivenStateWasteCodes)(container, IN_ACUTE_WASTE_CODES);
        if (hasAcuteStateWasteCode.value === undefined) {
            return { missing: [...hasAcuteStateWasteCode.missing] };
        }
        if (hasAcuteStateWasteCode.value) {
            return { value: "ACUTE" };
        }
        // STATE_REGULATED is non-acute pending the waste team's per-state decision.
        if (container.classification === browser_1.WasteClassification.STATE_REGULATED) {
            return { value: "NON_ACUTE" };
        }
        return _FEDERAL_1.Federal.category(container);
    }
    /** The federal container thresholds, with move windows following this state's acute codes. */
    containerThresholds(situation) {
        return _FEDERAL_1.Federal.containerThresholds(this, situation);
    }
}
exports.IndianaRules = IndianaRules;
//# sourceMappingURL=IN.js.map